import { useEffect } from 'react';
import { Tooltip } from 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DollarSign, Percent, TrendingDown, TrendingUp } from "react-feather";
import useTranslation from "../hooks/translations";

function CostsDistributionList({ sourceType, data }) {
  const translations = useTranslation();

  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach((el) => new Tooltip(el));
  }, []);

  return (
    <div className="list-group list-group-flush">
      {/* Header Row (Text + Icons for clarity) */}
      <div className="d-flex justify-content-between px-0 py-2 text-muted small fw-bold text-uppercase">
        <div className="flex-grow-1">
          {sourceType}
        </div>
        <div className="text-center" style={{ width: '80px' }}>
          <span data-bs-toggle="tooltip" title={translations.percentageOfIncome}>
            <TrendingUp className="feather-m" />
            <Percent className="feather-sm" />
          </span>
        </div>
        <div className="text-center" style={{ width: '80px' }}>
          <span data-bs-toggle="tooltip" title={translations.percentageOfCost}>
            <TrendingDown className="feather-m" />
            <Percent className="feather-sm" />
          </span>
        </div>
        <div className="text-end d-none d-md-block" style={{ width: '120px' }}>
          <DollarSign className="feather-m" data-bs-toggle="tooltip" title={translations.nominalValue} />
        </div>
      </div>

      {/* Data Rows */}
      {data.map((item, idx) => (
        <div
          key={idx}
          className="d-flex align-items-center justify-content-between px-0 py-2 small border-top"
        >
          <div className="flex-grow-1 d-flex align-items-center">
            <FontAwesomeIcon icon="circle"
                             className="fa-sm me-1"
                             color={item.color}/>
            {item.label}
          </div>
          <div className="text-center" style={{ width: '80px' }}>
            {item.percentageOfIncome}%
          </div>
          <div className="text-center" style={{ width: '80px' }}>
            {item.percentageOfCost}%
          </div>
          <div className="text-end d-none d-md-block" style={{ width: '120px' }}>
            {item.nominalValue}
          </div>
        </div>
      ))}
    </div>
  );
}

export default CostsDistributionList;
